import { render } from "./ModelPage.vue?vue&type=template&id=edf89442&scoped=true"
import script from "./ModelPage.vue?vue&type=script&lang=js"
export * from "./ModelPage.vue?vue&type=script&lang=js"

import "./ModelPage.vue?vue&type=style&index=0&id=edf89442&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edf89442"]])

export default __exports__